export default {
  data() {
    return {
      status1: [
        { label: '待处理', value: 'school_passed' },
        { label: '录用', value: 'enterprise_pass' },
        { label: '不合适', value: 'enterprise_reject' },
      ],
    }
  },
  methods: {
    // 删除属性值为false的属性
    delNullVal(obj) {
      var newObj = {}
      for (let key in obj) {
        if (obj[key]) {
          newObj[key] = obj[key]
        }
      }
      return newObj
    },
    // 根据属性名删除属性
    delProps(obj, props) {
      props.forEach(item => {
        if (obj.hasOwnProperty(item)) {
          delete obj[item]
        }
      })
    },
    formatStatus1(row) {
      for (let item of this.status1) {
        if (item.value === row.apply_status) {
          return item.label
        }
      }
    },
    formatLocation(row) {
      let name = ''
      if (row.province_name) {
        name = row.province_name
      }
      if (row.city_name) {
        name = name + '  ' + row.city_name
      }
      if (row.county_name) {
        name = name + '  ' + row.county_name
      }
      return name
    },
    formatFood(val) {
      switch (val) {
        case 0:
          return '未知'
        case 157:
          return '未知'
        case 158:
          return '包吃'
        case 159:
          return '包住'
        case 160:
          return '包吃住'
        case 161:
          return '不包吃住'
      }
    },
    formatSalary(val) {
      if (val.indexOf('面议') == -1) {
        return val
      }
      else {
        return '面议'
      }
    },
    formatEdu(val) {
      switch (val) {
        case 1:
          return '中专'
        case 2:
          return '大专'
        case 3:
          return '本科'
        case 4:
          return '研究生'
      }
    },
    formatProv(val) {
      // console.log(val)
      if (!val) {
        return ''
      }
      let prov = ''

      this.$store.state.provinces.forEach(item => {
        if (item.id == val) {
          prov = item.name
        }
      })
      return prov
    },
    formatCity(citys, cityId) {
      if (!cityId) {
        return ''
      }
      let city = ''

      citys.forEach(item => {
        if (item.id == cityId) {
          city = item.name
          return
        }
      })
      return city
    },
    formatPay(val) {
      switch (val) {
        case 'paid':
          return '已付费'
        case 'no_paid':
          return '未付费'
      }
    },
    formatApplyStatus(val) {
      switch (val) {
        case 'no_audit':
          return '待处理'
        case 'pass':
          return '已通过'
        case 'no_pass':
          return '未通过'
        case 'no_call':
          return '未接通'
        case 'dead_number':
          return '空号'
        case 'interest':
          return '感兴趣'
        // case 'student':
        // case 'student_shixi':
        // case 'school_passed':
        // case 'school_refused':
        //   return '待处理'
        // case 'enterprise_passed':
        //   return '已录用'
        // case 'enterprise_refused':
        //   return '不合适'
      }
    },
    // 路由跳转
    pushRouter(path, query) {
      this.$router.push({
        path,
        query
      })
    }
  }
}